import React, { useState } from "react";
import {
  Dialog,
  IconButton,
  Grid,
  TextField,
  Button,
  Select,
  MenuItem,
  InputAdornment,
  Box,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import { toast } from "react-toastify";
import environment from "../../enviroment";

const OnboardClientDialog = ({ open, handleClose }) => {
  // State variables for form fields
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    department: "",
    email: "",
    mobileNumber: "",
    password: "",
    role:"CLIENT"
  });

  // Handle input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelectChange = (event) => {
    const { value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      department: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async () => {
    const url = `${environment.endPoint}/api/v1/website/user/register`; // Dummy URL

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const responseData = await response.json();
        console.log("Form submitted successfully:", responseData);
      toast.success("Employee Created")
        handleClose(); // Close the dialog after submission
      } else {
        console.error("Failed to submit the form");
        alert("Failed to submit the form. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred. Please try again later.");
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs" sx={{borderRadius:5}}>
      <Box sx={{ padding: "24px" ,borderRadius:20}}>
        {/* Title Section */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Onboard New CLIENT
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Form Section */}
        <Grid container spacing={2}>
          {/* First Name Field */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="First Name"
              name="firstName"
              placeholder="Enter first name"
              variant="outlined"
              value={formData.firstName}
              onChange={handleInputChange}
              sx={{ background: "#fff" }}
            />
          </Grid>

          {/* Last Name Field */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Last Name"
              name="lastName"
              placeholder="Enter last name"
              variant="outlined"
              value={formData.lastName}
              onChange={handleInputChange}
              sx={{ background: "#fff" }}
            />
          </Grid>

          {/* Department Dropdown */}
          <Grid item xs={12}>
            <Select
              fullWidth
              value={formData.role}
              onChange={e=>setFormData({...formData,role:e.target.value})}
              displayEmpty
              sx={{
                background: "#fff",
                "& .MuiSelect-outlined": {
                  padding: "10px",
                },
              }}
            >
              <MenuItem value="" disabled>
                Choose department
              </MenuItem>
              <MenuItem value="CLIENT">CLIENT</MenuItem>
              
            </Select>
          </Grid>

          {/* Email Field */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              placeholder="Enter email"
              variant="outlined"
              value={formData.email}
              onChange={handleInputChange}
              sx={{ background: "#fff" }}
            />
          </Grid>

          {/* Mobile Number Field */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Mobile Number"
              name="phoneNumber"
              placeholder="Enter mobile number"
              variant="outlined"
              value={formData.phoneNumber}
              onChange={handleInputChange}
              sx={{ background: "#fff" }}
            />
          </Grid>

          {/* Password Field */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Password"
              name="password"
              placeholder="Create password"
              variant="outlined"
              value={formData.password}
              onChange={handleInputChange}
              sx={{ background: "#fff" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton>
                      <VisibilityIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          {/* Generate Random Password Button */}
          <Grid item xs={12}>
            <Button
              variant="outlined"
              fullWidth
              startIcon={<ShuffleIcon />}
              onClick={() =>
                setFormData((prevData) => ({
                  ...prevData,
                  password: Math.random().toString(36).slice(-8),
                }))
              }
              sx={{
                textTransform: "none",
                border: "1px solid #ddd",
                color: "#666",
                background: "#F9FAFC",
              }}
            >
              Generate random password
            </Button>
          </Grid>

          {/* Submit Button */}
          <Grid item xs={12}>
            <Button
              variant="contained"
              fullWidth
              onClick={handleSubmit}
              sx={{
                textTransform: "none",
                background: "#28a745",
                color: "#fff",
                ":hover": { background: "#218838" },
              }}
            >
              Confirm and send
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
};

export default OnboardClientDialog;
